import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  setImagePreviewData,
  setSelectedAppsData,
  setSelectedRoleData,
  setTempUserId,
  setTenantDepartmentFormData,
  setUserFormData,
  setUserTenantDepartmentData,
} from "@services/StateManagement/UserFormSlice";

const ResetStoredUserOnRouteChange = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const tempUserId = useSelector((state) => state.userForm.tempUserId);

  useEffect(() => {
    if (
      !location.pathname.startsWith(
        "/KAKELY/departments/settings/create/Master",
      ) &&
      !location.pathname.startsWith("/YOBELY/broadcast_groups/create/Master") &&
      tempUserId !== null
    ) {
      dispatch(setUserFormData(null));
      dispatch(setTempUserId(null));
      dispatch(setTenantDepartmentFormData(null));
      dispatch(setUserTenantDepartmentData(null));
      dispatch(setSelectedAppsData(null));
      dispatch(setSelectedRoleData(null));
      dispatch(setImagePreviewData(null));
    }
  }, [location.pathname, dispatch]);

  return null;
};

export default ResetStoredUserOnRouteChange;
